import React, { FC } from "react"
import { Dialog, DialogActions, DialogContent, DialogContentText, Typography } from "@mui/material"
import { UButton } from "@/components/index"
import { useTranslation } from "react-i18next"

type Props = {
  open: boolean
  /** Integration UI key (e.g. EasyRx); drives copy until per-scanner i18n exists */
  scannerName: string
  onOk: () => void
  onClose: () => void
}

/** Not-connected modal for integration scanners; i18n is EasyRx-only until more ship. */
export const IntegrationNotConnectedDialog: FC<Props> = ({
  open,
  scannerName,
  onOk,
  onClose,
}) => {
  const { t } = useTranslation("common")

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <DialogContentText
          component="div"
          id="integration-not-connected-description"
          data-integration-scanner={scannerName}
          sx={{ color: "rgba(0,0,0,1)", fontSize: "18px" }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 1 }}>
            {t("settings.Integrations.easyRxScannerNotConnectedTitle")}
          </Typography>
          {t("settings.Integrations.easyRxScannerNotConnectedBody")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <UButton
          variant="contained"
          btnText={t("settings.Integrations.easyRxBtnOk")}
          sxProp={{
            width: "auto",
            height: "36px",
            padding: "6px 16px",
          }}
          onClickHandler={onOk}
        />
      </DialogActions>
    </Dialog>
  )
}
